import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

const styles = {
  error: {
    color: '#fff',
    fontSize: '14px',
    backgroundColor: '#f44336',
    padding: '1px',
    marginTop: '10px',
    marginBottom: '15px',
  },
};

function ErrorMessage(props) {
  if (props.error) {
    return (
      <Paper style={styles.error} elevation={2}>
        <p>
          {props.error}
        </p>
      </Paper>
    );
  } else {
    return null;
  }
}

ErrorMessage.propTypes = {
  error: PropTypes.string,
};

export default ErrorMessage;
